import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("clients", ["salesPersonList"])
  },
  methods: {
    FilterUsersByRole(arr, roles) {
      const rolesArr = roles;
      // if(arr){
      //     return   arr.filter(user=>user.role !== 0)
      // }
      let filteredUsers = arr; //this.salesPersonList
      rolesArr.forEach(role => {
        filteredUsers = filteredUsers.filter(user => user.role !== role);
      });
      return filteredUsers;
      // return  this.salesPersonList.filter(user=>user.role === role)
    }
  }
};
